import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";

const formatCurrency = (value) => {
  if (value === undefined || value === null || value === "") return "";
  const num = parseFloat(value);
  if (isNaN(num)) return "";
  return num.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const CurrencyWidget = (props) => {
  const { id, value, required, disabled, readonly, autofocus, onChange, onBlur, onFocus, options, schema, label } =
    props;

  const [isFocused, setIsFocused] = useState(false);
  const [rawValue, setRawValue] = useState(value !== undefined ? String(value) : "");

  const handleChange = (event) => {
    let input = event.target.value;

    // Allow digits, a single decimal point, and up to 2 decimal places
    input = input.replace(/[^\d.]/g, "");

    // Prevent multiple decimal points
    const parts = input.split(".");
    if (parts.length > 2) {
      input = parts[0] + "." + parts.slice(1).join("");
    }

    // Limit to 2 decimal places
    if (parts[1] !== undefined) {
      input = parts[0] + "." + parts[1].slice(0, 2);
    }

    setRawValue(input);

    onChange(input || undefined);
  };

  const handleFocus = (event) => {
    setIsFocused(true);
    setRawValue(value !== undefined && value !== null ? String(value) : "");
    if (onFocus) onFocus(id, event.target.value);
  };

  const handleBlur = (event) => {
    setIsFocused(false);
    onChange(rawValue || undefined);
    if (onBlur) onBlur(id, rawValue);
  };

  const displayValue = isFocused ? rawValue : formatCurrency(value);

  return (
    <TextField
      id={id}
      label={label || schema.title}
      value={displayValue}
      required={required}
      disabled={disabled}
      readOnly={readonly}
      autoFocus={autofocus}
      onChange={handleChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
      fullWidth
      variant="outlined"
      size="small"
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={{
        startAdornment: <InputAdornment position="start">$</InputAdornment>,
      }}
    />
  );
};

export default CurrencyWidget;
